import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  cardClass: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2),
    background: theme.palette.background.paper,
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.background.lightOverlay}`,

    [theme.breakpoints.up('sm')]: {
      width: ({ largeContent }) => (largeContent ? '100%' : '30%'),
    },

    [theme.breakpoints.up('md')]: {
      width: ({ largeContent }) => (largeContent ? '30%' : '30%'),
    },
  },

  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      minHeight: 80,
    },

    [theme.breakpoints.up('md')]: {
      minHeight: 50,
      height: 'auto',
    },
  },

  titleClass: {
    fontFamily: 'Roboto Condensed',
    textTransform: 'uppercase',
    fontWeight: theme.typography.fontWeightSemiBold,
    color: theme.palette.text.disabled,
  },

  textClass: {
    [theme.breakpoints.up('sm')]: {
      minHeight: 120,
    },

    [theme.breakpoints.up('md')]: {
      minHeight: 50,
      height: 'auto',
    },
  },

  divider: {
    margin: theme.spacing(2),
  },
}))
